export default __webpack_public_path__ + "static/media/logout.f0e6ccf5.svg";